/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MathIcon = /*#__PURE__*/ createSvgIcon(
  'MathIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M7.5 12.5v1a.486.486 0 00.5.5.485.485 0 00.5-.5v-1h1a.485.485 0 00.5-.5.486.486 0 00-.5-.5h-1v-1A.486.486 0 008 10a.485.485 0 00-.5.5v1h-1a.485.485 0 00-.5.5.486.486 0 00.5.5h1zm4 .75h2a.485.485 0 00.5-.5.485.485 0 00-.5-.5h-2a.485.485 0 00-.5.5.485.485 0 00.5.5zm0-1.5h2a.485.485 0 00.5-.5.485.485 0 00-.5-.5h-2a.485.485 0 00-.5.5.485.485 0 00.5.5zm-5-3.48h2a.486.486 0 00.5-.5.486.486 0 00-.5-.5h-2a.486.486 0 00-.5.5.486.486 0 00.5.5zM4.5 17c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 15.5v-11c0-.412.147-.766.44-1.06.294-.293.648-.44 1.06-.44h11c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06v11c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-11zm0-1.5h11v-11h-11v11zm8-7.02l.708.707a.503.503 0 00.709 0 .482.482 0 00.146-.354.482.482 0 00-.146-.354l-.709-.708.709-.708a.503.503 0 000-.709.503.503 0 00-.708 0l-.709.708-.708-.708a.503.503 0 00-.709 0 .52.52 0 00-.156.354.423.423 0 00.156.354l.709.688-.709.708a.51.51 0 00-.156.344.47.47 0 00.156.365.503.503 0 00.709 0l.708-.688z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MathIcon;
